import { decode as base64_decode, encode as base64_encode } from "base-64";

import { postApi } from "../components/Utility";
import { action, makeObservable, observable } from "mobx";

import Cookies from "js-cookie";
class EmailMessageStore {
  emailMessage = [];
  allCompanyArray = [];
  total = 0;
  loading = false;
  rootStore;

  constructor(rootStore) {
    makeObservable(this, {
      emailMessage: observable,
      allCompanyArray: observable,
      total: observable,
      loading: observable,
      loadData: action,
    });
    this.rootStore = rootStore;
  }

  async loadData({ offset, limit }) {
    this.loading = true;
    var postData = {
      value: "",
      isadmin: JSON.parse(base64_decode(Cookies.get("data"))).isadmin,
      companyId: JSON.parse(base64_decode(Cookies.get("data"))).userCompanyId,
    };
    var response = await postApi
      .getClient("NodeCoreUrl")
      .get("/company/getCompanyList", { params: postData });
    this.allCompanyArray = response.data.data.companydata;
  }

  async sendEmailMessage(obj) {
    var postData = obj;
    var response = await postApi
      .getClient("NodeCoreUrl")
      .post("/emailMessage/sendEmail", postData);
    return response;
  }
  // async sendEmailMessage(obj) {
  //   var postData = obj;
  //   const base64Input = await base64_encode(JSON.stringify(postData));
  //   var response = await postApi
  //     .getClient()
  //     .post("index.php?c=user&a=sendEmailMessage", "postData=" + base64Input);
  //   return response;
  // }
}

export default EmailMessageStore;
